import React from 'react';
import { isSmartPhone } from '../../utilities/helper';
import useTheme from '../../utilities/hooks/theme';
import './index.css';

const GamesPosterCard = ({ item, idx, onGamePosterClick, isFooter = true }: any) => {
  const { DashboardTheme: theme } = useTheme();
  const gamesPosterTextStyle = {
    backgroundColor: theme.gamePosterFooterBg
  };
  return (
    <div
      key={idx}
      className={isSmartPhone ? 'games_poster_container_mWeb' : 'games_poster_container'}
      onClick={() => onGamePosterClick(item)}>
      <img
        key={idx}
        className={`${isSmartPhone ? 'games_poster_img_bg_mWeb' : 'games_poster_img_bg'}`}
        style={{ marginLeft: isSmartPhone && idx !== 0 ? '10px' : '0px' }}
        src={item.bgImgSrc}
      />
      <img
        className={`${isSmartPhone ? 'games_poster_game_img_mWeb' : 'games_poster_game_img'}`}
        src={item.gameImgSrc}
      />
      <img
        className={`${isSmartPhone ? 'games_poster_title_img_mWeb' : 'games_poster_title_img'}`}
        src={item.titleImgSrc}
      />
      {isFooter && (
        <div className="games_poster_text_container" style={gamesPosterTextStyle}>
          <p>{item.gameDescription1}</p>
          <p>{item.gameDescription2}</p>
        </div>
      )}
    </div>
  );
};

export default GamesPosterCard;
